<template>
  <tr :class="{ 'is-Inactive': subscribed === false && allowSubscription === true }">
    <td>
      <label class="postsTable__ItemTitle" :for="allowSubscription === false ? `sel${index + 1}` : ''">{{
        item.url
      }}</label>
      <ul class="postsTable__ItemActions">
        <li>
          <router-link :to="{ path: `website/${item.id}`, params: { id: item.id } }" append>Edit</router-link>
        </li>
        <li v-if="allowSubscription === true">
          <button @click="subscribe(true)" v-if="subscribed === false">Subscribe</button>
          <button @click="subscribe(false)" v-else>Unsubscribe</button>
        </li>
      </ul>
    </td>
  </tr>
</template>

<script>
import GetProperty from '@/components/mixins/GetProperty.js'

export default {
  props: ['item', 'index', 'websites', 'allowSubscription', 'subscriptions'],
  mixins: [GetProperty],
  name: 'Website',
  data() {
    return {
      subscription: null,
    }
  },
  computed: {
    lang() {
      return this.$store.state.ui.lang
    },
    subscribed: {
      set(val) {
        this.subscription = val
      },
      get() {
        if (this.subscription !== null) return this.subscription
        if (this.websites && this.websites.find((website) => website.id === this.item.id)) return true
        return false
      },
    },
  },
  methods: {
    subscribe(value) {
      if (this.subscriptions.length === 1 && value === false) {
        alert('You may not choose less than one active website per organisation.')
        return false
      }
      this.subscribed = value
      this.$emit('subscribe', this.subscribed)
    },
  },
}
</script>
